/* eslint-disable */
import Cookies from 'js-cookie'
import MobileDetect from 'mobile-detect'

export const TOKEN_KEY = 'bcToken'

/**
 * @param {String} text 需要脱敏的字段
 * @description 将字段脱敏
 */
export const setMobileStar = (txt) => {
    if (!txt) {
        return ''
    }
    var starNum = txt.length - 7
    var starText = '****'
    if (starNum > 0) {
        starText = ''
        for (var i = 0; i < starNum; i++) {
            starText = starText + '*'
        }
    }
    txt = txt.substring(0, 3) + starText + txt.substring(txt.length - 4)
    return txt
}
/**
 * @param {String} text 需要脱敏的字段
 * @description 将字段脱敏
 */
export const setIdCardStar = (txt) => {
    if (!txt) {
        return ''
    }
    var starNum = txt.length - 10
    var starText = '****'
    if (starNum > 0) {
        starText = ''
        for (var i = 0; i < starNum; i++) {
            starText = starText + '*'
        }
    }
    txt = txt.substring(0, 6) + starText + txt.substring(txt.length - 4)
    return txt
}
/**
 * @param {String, num} token 时间
 * @description token存入cookie中
 */
export const setToken = (token, date) => {
    Cookies.set(TOKEN_KEY, token, { expires: date || 1 })
}

export const getToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) return token
    else return false
}

export const setCookie = (name, value, date) => {
    Cookies.set(name, value, { expires: date || 1 })
}

export const getCookie = (name) => {
    const value = Cookies.get(name)
    if (value) return value
    else return false
}
export const removeCookie = (key) => {
    Cookies.remove(key)
}

export const getSessionKey = () => {
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
    return {
        ...user,
        userId: user.userId || user.user_id
    }
}

export const setSessionKey = (params = {}) => {
    const sessionKey = getSessionKey()
    if (!params.sessionKey) params.sessionKey = sessionKey.sessionKey
    localStorage.setItem('userInfo', JSON.stringify(params || {}))
}

export const removeSessionKey = () => {
    localStorage.removeItem('userInfo')
}

export const isLogin = () => {
    const _user = getSessionKey()
    console.log('_user.userId =>', _user.userId, _user.sessionKey)
    if (!!_user.userId && !!_user.sessionKey) return true
    const user = getQuery()
    if (!!user.sessionKey && !!user.userId && window.location.pathname === '/login') {
        setSessionKey({
            ..._user,
            userId: user.userId,
            sessionKey: user.sessionKey
        })
        return true
    }
    return false
}

export const getQuery = () => {
    const obj = {}
    const search = window.location.search.slice(1)
    const list = search.split('&')
    list.forEach((item) => {
        const arr = item.split('=')
        const key = arr[0]
        const value = arr[1]
        if (key && value !== undefined) {
            obj[key] = value
        }
    })
    return obj
}

// 获取从1987至去年的年份
export const getGameFilterYears = () => {
    const years = []
    const cureentYear = new Date().getFullYear()
    for (let i = cureentYear; i > 1987; i--) {
        years.push({
            label: i - 1,
            value: i - 1
        })
    }

    return years
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = (url) => {
    var url = url || window.location.hash
    if (url.indexOf('?')) {
        var search = url.substring(url.lastIndexOf('?') + 1)
        var obj = {}
        var reg = /([^?&=]+)=([^?&=]*)/g
        search.replace(reg, function (rs, $1, $2) {
            var name = decodeURIComponent($1)
            var val = decodeURIComponent($2)
            val = String(val)
            obj[name] = val
            return rs
        })
    }
    return obj
}
/* *
 * @param {JSON} data
 * @description json转URL参数
 * */
export const parseParams = (data) => {
    try {
        return Object.keys(data)
            .map((key) => {
                if (data[key] == undefined) return ''
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            })
            .join('&')
    } catch (err) {
        return ''
    }
}
/* *
 * @param {JSON} data
 * @description 返回是否时空对象
 * */
export const isEmptObject = (data) => {
    var b = JSON.stringify(data) == '{}'
    return b
}

//最大长度
export const maxLength = (value, maxNum) => {
    const num = String(value)
    if (num.length > maxNum) return num.slice(0, maxNum)
    else return num
}

export const isWeXin = () => {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase()
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}
/*
 * 判断当前设备类型是否为Android
 **/
export const isAndroidApp = () => {
    let u = navigator.userAgent
    // console.log(u)
    if (u.indexOf('app/Android') != -1) return true
    return false
}
/*
 * 判断当前设备类型是否为ios
 **/
export const isIOSApp = () => {
    let u = navigator.userAgent
    // console.log(u)
    if (u.indexOf('app/iOS') != -1) return true
    return false
}
/*
 * 判断当前设备类型是否为ios
 **/
export const isIOSApp1 = () => {
    let u = navigator.userAgent
    if (u.indexOf('IosMJ') != -1) return true
    return false
}

export const isIOS = () => {
    let u = navigator.userAgent,
        app = navigator.appVersion
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    return isIOS
}

/**
 *  @param {obj} vm
 *  @description 判断当前设备 跳转到不同的view
 *  @opt {android: 'com.lanjinrong.app.mvp.view.PosterActivity,邀请会员,type,2,int', ios: 'LJAddMemberViewController|{"haibaoType":2}', h5: '/'}
 **/
export const jumpAppController = (opt, vm) => {
    if (isAndroidApp && opt.android) {
        let arr = opt.android.split(',')
        window.control.toActivity(arr[0], arr[1], arr[2], arr[3], arr[4])
    } else if (isIOSApp && opt.ios) {
        let arr = opt.ios.split('|')
        if (arr.length > 1) {
            return gotoJumpVC(arr[0], arr[1])
        }
        gotoJumpVC(arr[0])
    } else {
        if (opt.h5.indexOf('http') === -1) {
            vm.$router.push({ path: opt.h5 ? opt.h5 : '/' })
        } else {
            window.location.href = opt.h5
        }
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

export function setMobileLoacl(mobile = '') {
    try {
        let holderPerson = JSON.parse(localStorage.getItem('holderPerson')) || {}
        holderPerson.holder_phone_number = mobile
        localStorage.setItem('holderPerson', JSON.stringify(holderPerson))
    } catch (error) {
        console.log(error)
    }
}

/**
 * 获取机型
 *
 * * */
export function getMobileInfo() {
    const deviceType = navigator.userAgent // 获取userAgent信息
    const md = new MobileDetect(deviceType) // 实例化mobile-detect
    let os = md.os() // 获取系统
    let model = ''

    if (os === 'iOS') {
        os += md.version('iPhone')
        model = md.mobile()
    } else if (os === 'AndroidOS') {
        os += md.version('Android')

        if (deviceType.indexOf('Build/') > -1) {
            // const sss = deviceType.split(";");

            // const i = sss.contains("Build/");
            const sss = deviceType.split(';')
            let i = -1
            sss.forEach((item, index) => {
                if (item.indexOf('Build/') !== -1) {
                    i = index
                }
            })

            if (i > -1) {
                model = sss[i].substring(0, sss[i].indexOf('Build/'))
            }
        } else if (deviceType.indexOf('HuaweiBrowser') > 0) {
            model = md.mobile()
            //   const sss = deviceType.split(";");
            //   const i = sss.contains("Android");
            const sss = deviceType.split(';')
            let i = -1
            sss.forEach((item, index) => {
                if (item.indexOf('Android') !== -1) {
                    i = index
                }
            })

            if (i > -1) {
                model = sss[i * 1 + 1]
            }
        } else if (deviceType.indexOf('wv') > -1) {
            const sss = deviceType.split(')')[0]
            const ssss = sss.split('(')[1]
            const sssss = ssss.split(';')
            if (sssss.length > 3) {
                model = sssss[2]
            }
        }
    }

    if (model) {
        model = trim(model)
    }

    return {
        os,
        model
    }
}
/**
 * 获取版本
 * ** */
export function getAppVersion() {
    const deviceType = window.navigator.userAgent // 获取userAgent信息

    // androw:
    // const deviceType = `Mozilla/5.0 (Linux; Android 10; BMH-AN10 Build/HUAWEIBMH-AN10; wv) AppleWebKit/537.36 (KHTML, like Gecko)
    // Version/4.0 Chrome/78.0.3904.108 Mobile Safari/537.36 aweme_110100 JsSdk/1.0 NetType/WIFI Channel/huawei_1 AppName/aweme app_version/11.1.0 ByteLocale/zh-Hans-CN Region/CN AppSkin/black"`;

    // ios:
    // const deviceType = `Mozilla/5.0 (iPhone; CPU iPhone OS 12_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16C50 aweme_10.8.0 JsSdk/2.0
    // NetType/WIFI Channel/App Store ByteLocale/zh Region/CN RevealType/Dialog WKWebView/1`;

    const md = new MobileDetect(deviceType) // 实例化mobile-detect
    let os = md.os() // 获取系统
    let version = ''
    const deviceTypeToLowerCase = md.ua.toLowerCase()

    if (os === 'iOS') {
        os += md.version('iPhone')

        if (deviceTypeToLowerCase.indexOf('aweme_') > -1) {
            const sss = deviceTypeToLowerCase.split('aweme_')
            version = sss[1].substring(0, sss[1].indexOf('jssdk/'))
        }
    } else if (os === 'AndroidOS') {
        os += md.version('Android')

        if (deviceTypeToLowerCase.indexOf('app_version/') > -1) {
            const sss = deviceTypeToLowerCase.split('app_version/')
            version = sss[1].substring(0, sss[1].indexOf('bytelocale/'))
        }
    }

    if (version) {
        version = trim(version)
    }

    return {
        os,
        version
    }
}

export function getNetworkType() {
    const ua = navigator.userAgent
    let networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
    networkStr = networkStr.toLowerCase().replace('nettype/', '')
    let networkType
    switch (networkStr) {
        case 'wifi':
            networkType = 'wifi'
            break
        case '4g':
            networkType = '4g'
            break
        case '3g':
            networkType = '3g'
            break
        case '3gnet':
            networkType = '3g'
            break
        case '2g':
            networkType = '2g'
            break
        default:
            networkType = 'other'
    }
    return networkType
}

function trim(str, type) {
    type = type || 2
    switch (type) {
        case 1:
            return str.replace(/\s+/g, '')
        case 2:
            return str.replace(/(^\s*)|(\s*$)/g, '')
        case 3:
            return str.replace(/(^\s*)/g, '')
        case 4:
            return str.replace(/(\s*$)/g, '')
        default:
            return str
    }
}
